import { apiCall } from "../service/api-service";

export const getContactsListApi = async (params) => {
  return apiCall("GET", `contact${params}`);
};

export const createContactApi = async (data) => {
  return apiCall("POST", "contact", data);
};

export const getContactDetailsApi = async (id) => {
  const response = await apiCall("GET", `contact/edit/${id}`);
  return response.data;
};

export const updateContactApi = async (data, id) => {
  return apiCall("PUT", `contact/${id}`, data);
};

export const getContactDataApi = async (id) => {
  return apiCall("GET", `contact/view/${id}`);
};

export const bulkDeleteContactsApi = async (ids) => {
  const data = Array.isArray(ids) ? { ids } : ids;
  return apiCall("DELETE", "contact/bulk_delete", data);
};

export const getActivityApi = async (id) => {
  return apiCall("GET", `contact/activities/${id}`);
};

export const getHistoryApi = async (id) => {
  return apiCall("GET", `contact/history/${id}`);
};

export const uploadAttachmentsApi = async (id, data) => {
  return apiCall("POST", `contact/add_attachments/${id}`, data);
};
